import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

export interface sumCustomStats { group: string, parking_events: number, occupancy: number };
@Injectable({ providedIn: 'root' })
export class GroupEventsService {

  private base_url = "";

  private customStats$: BehaviorSubject<any[]> = new BehaviorSubject([])
  public stats$: BehaviorSubject<any[]> = new BehaviorSubject([])
  private customSumStats$: BehaviorSubject<sumCustomStats[]> = new BehaviorSubject([{ group: null, parking_events: 0, occupancy: 0 }])
  public sumStats$: BehaviorSubject<sumCustomStats[]> = new BehaviorSubject([{ group: null, parking_events: 0, occupancy: 0 }])

  constructor(private http: HttpClient, private authService: AuthService) {
    this.base_url = environment.base_url;
  }

  setCustomStats(data: any[]) {
    this.customStats$.next(data)
    this.stats$.next(data)
  }

  setSumCustomStats(sumData: sumCustomStats[]) {
    this.customSumStats$.next(sumData)
    this.sumStats$.next(sumData)
  }

  getStats(): Observable<any[]> {
    return this.stats$.asObservable();
  }

  getSumStats(): Observable<sumCustomStats[]> {
    return this.sumStats$.asObservable();
  }

  getCustomGroupStats(groupID: number, filters: Filters) {

    let url = `${this.base_url}/api/customgroupstat`
    let flts: any;
    if (filters.starts_after !== null || filters.ends_before !== null) {
      flts = `&starts_after=${filters.starts_after}&ends_before=${filters.ends_before}`
    } else {
      flts = ``
    }

    let finalUrl = ''
    if (groupID !== null) {
      finalUrl = `?group=${groupID}${flts}`
    } else {
      finalUrl = ``
    }
    return this.http.get<any[]>(`${url}${finalUrl}`)
      .pipe(
        retry(2),
        map(result => {
          let array: any[] = [];
          array = result['data']['occupancy'].map((x,i) => Object.assign({occupancy :x, parking_events :result['data']['parking_events'][i]}))
          // result['data']['occupancy'].forEach(element => {
          //   array.push({x :result['data']['occupancy'], y: result['data']['parking_events']})
          // });
          return array
        }),
        catchError(err => {
          return throwError(err)
        })
      );
  }

  getCustomSumGroupStats(groupID: number, filters: Filters) {
    //let url = `${this.base_url}/api/sumcustomsgroupstat`
    let url = `${this.base_url}/api/customgroupstat`
    let flts: any;
    if (filters.starts_after !== null || filters.ends_before !== null) {
      flts = `&starts_after=${filters.starts_after}&ends_before=${filters.ends_before}`
    } else {
      flts = ``
    }

    let finalUrl = ''
    if (groupID !== null) {
      // finalUrl = `?group=${groupID}${flts}`
      finalUrl = `?group=${groupID}${flts}&sum=True`
    } else {
      finalUrl = ``
    }
    return this.http.get<sumCustomStats[]>(`${url}${finalUrl}`)
      .pipe(
        retry(2),
        map(result => {
          let array: any[] = [];
          array.push(result['data'])
          return array
        }),
        catchError(err => {
          return throwError(err)
        })
      );
  }

  /**
  *
  * @param filters <Interface> Filters
  * @description The filters must be of the format YYYY-MM-DD HH:MM[:ss[.uuuuuu]][TZ] format.']
  * @description > /api/occupancy/starts_after=2020-09-[currentDay]
  * @description > /api/occupancy/ends_before=2020-09-[endDate]
  * @description HH:MM[:ss[.uuuuuu]][TZ] is for future requirement
  */
  getEventsAtGroupLevel(groupID?: number, filters?: Filters, last?: boolean) {
    let url = `${this.base_url}/api/groupstat`
    let flts: any;
    if (filters.starts_after !== null || filters.ends_before !== null) {
      if (filters.starts_after !== null && filters.ends_before == null) {
        flts = last && last !== undefined ? `?starts_after=${filters.starts_after}&last=1` : `?starts_after=${filters.starts_after}`
      }
      if (filters.starts_after == null && filters.ends_before !== null) {
        flts = `?ends_before=${filters.ends_before}`
      }
      if (filters.starts_after !== null && filters.ends_before !== null) {
        flts = `?starts_after=${filters.starts_after}&ends_before=${filters.ends_before}`
      }

    } else {
      flts = ``
    }

    let finalUrl = ''
    if (groupID !== null) {
      finalUrl = `?group=${groupID}${flts}`
    } else {
      finalUrl = `${flts}`
    }
    return this.http.get<any[]>(`${url}${finalUrl}`)
      .pipe(
        retry(2),
        map(result => {
          return result['data']
        }),
        catchError(err => {
          return throwError(err)
        })
      );
  }


getGroupHourlyEvents(groupID?: any, filters?: Filters, last?: boolean) {
  let url = `${this.base_url}/api/grouphourlystats`
  let flts: any;
  if (filters.starts_after !== null || filters.ends_before !== null) {
    if (filters.starts_after !== null && filters.ends_before == null) {
      flts = last && last !== undefined ? `&after=${filters.starts_after}&last=1` : `&after=${filters.starts_after}`
    }
    if (filters.starts_after == null && filters.ends_before !== null) {
      flts = `&before=${filters.ends_before}`
    }
    if (filters.starts_after !== null && filters.ends_before !== null) {
      flts = `&after=${filters.starts_after}&before=${filters.ends_before}`
    }

  } else {
    flts = ``
  }

  let finalUrl = ''
  if (groupID !== null || groupID !== undefined) {
    finalUrl = `?group=${groupID}${flts}`
  } else {
    finalUrl = `${flts}`
  }
  console.log("final", finalUrl)
  return this.http.get<any[]>(`${url}${finalUrl}`)
    .pipe(
      retry(2),
      map(result => {
        console.log("result", result)
        return result['data']
      }),
      catchError(err => {
        return throwError(err)
      })
    );
}


getGroupWeeklyEvents(groupID?: any, filters?: NewFilters, last?: boolean) {
  let url = `${this.base_url}/api/groupweeklystats`
  let flts: any;
  if (filters.after !== null || filters.before !== null) {
    if (filters.after !== null && filters.before == null) {
      flts = last && last !== undefined ? `?after=${filters.after}&last=1` : `?after=${filters.after}`
    }
    if (filters.after == null && filters.before !== null) {
      flts = `?before=${filters.before}`
    }
    if (filters.after !== null && filters.before !== null) {
      flts = `?after=${filters.after}&ends_before=${filters.before}`
    }

  } else {
    flts = ``
  }

  let finalUrl = ''
  if (groupID !== null || groupID !== undefined) {
    finalUrl = `?group=${groupID}${flts}`
  } else {
    finalUrl = `${flts}`
  }
  console.log("final", finalUrl)
  return this.http.get<any[]>(`${url}${finalUrl}`)
    .pipe(
      retry(2),
      map(result => {
        console.log("result", result)
        return result['data']
      }),
      catchError(err => {
        return throwError(err)
      })
    );
}

getGroupMonthlyEvents(groupID?: any, filters?: NewFilters, last?: boolean) {
  let url = `${this.base_url}/api/groupmonthlystats`
  let flts: any;
  if (filters.after !== null || filters.before !== null) {
    if (filters.after !== null && filters.before == null) {
      flts = last && last !== undefined ? `?after=${filters.after}&last=1` : `?after=${filters.after}`
    }
    if (filters.after == null && filters.before !== null) {
      flts = `?before=${filters.before}`
    }
    if (filters.after !== null && filters.before !== null) {
      flts = `?after=${filters.after}&ends_before=${filters.before}`
    }

  } else {
    flts = ``
  }

  let finalUrl = ''
  if (groupID !== null || groupID !== undefined) {
    finalUrl = `?group=${groupID}${flts}`
  } else {
    finalUrl = `${flts}`
  }
  console.log("final", finalUrl)
  return this.http.get<any[]>(`${url}${finalUrl}`)
    .pipe(
      retry(2),
      map(result => {
        console.log("result", result)
        return result['data']
      }),
      catchError(err => {
        return throwError(err)
      })
    );
}

}
export interface Filters {
  groupID?: number;
  starts_after?: string;
  ends_before?: string;
}
export interface NewFilters {
  sensorSerial?: any;
  after?: string;
  before?: string;
}
